const addClassName = (status) => {
    if (status === "Completed") {
        return "Completed";
    } else if (status === "Report in review") {
        return "reportInReview";
    } else if (status === "In progress") {
        return "In-Progress";
    } else if (status === "Yet to start") {
        return "yetToStart";
    } else if (status === "expired") {
        return "expired";
    }
    return null;
};

export { addClassName }


// WEBPACK FOOTER //
// ./src/new/Utils/Add-ClassName.js